import { h } from 'preact';

import { useSelector } from 'react-redux';

import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';

function selectRmAccountData(state) {
  return state.rmAccountData.data;
}

export default function RunnerAppealMessage(_props) {
  const rmAccountData = useSelector(selectRmAccountData);

  let showMessage = false;

  if (rmAccountData != null) {
    const { engine } = rmAccountData;
    if (engine) {
      showMessage = !engine.enable_rpm;
    } else {
      showMessage = true;
    }
  }

  return (
    <Collapse in={showMessage}>
      <Alert severity="info">
        Enable RPM to track real time Core Web Vitals data. Tell your account
        manager or contact{' '}
        <a href="mailto:support@rebelmouse.com" target={'_blank'}>
          <b>support@rebelmouse.com</b>
        </a>{' '}
        to turn it on
      </Alert>
    </Collapse>
  );
}
